import TopicOne from "../meta-trader-web-terminal-contents/TopicOne";

const MetaTraderWebTerminalContentOne = () => {
  return (
    <>
      <TopicOne />

      <div className="how__work__platform">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="thumb-left">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/platforms/meta_trader_web_terminal/meta_trader_web_terminal_01.png"
                  }
                  alt="computer images"
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
              <div className="content-right">
                <h2>Freedom to Trade Without Limits</h2>
                <p>
                  MetaTrader Web Terminal offers the ultimate convenience for
                  traders who prefer accessibility over installation. Whether
                  you’re on a shared computer, switching devices, or simply want
                  a faster way to trade, this browser-based platform keeps you
                  connected to your trading account with just a few clicks.
                  Designed for traders who demand performance and flexibility,
                  it’s perfect for managing positions on the go without
                  compromising on speed or security. Its intuitive interface
                  mirrors the classic MetaTrader layout, ensuring a seamless
                  transition for both new and experienced users. With real-time
                  data flow and stable execution across devices, you can trade
                  confidently anytime, anywhere.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MetaTraderWebTerminalContentOne;
